import React from 'react';
import Pricing from '../../components/pricing';
import Layout from '../layout';

const PricingContainer = () => (
  <Layout>
    <Pricing />
  </Layout>
);

export default PricingContainer;
